import { render } from "./ProductDetail.vue?vue&type=template&id=4265b521"
import script from "./ProductDetail.vue?vue&type=script&lang=js"
export * from "./ProductDetail.vue?vue&type=script&lang=js"
script.render = render

export default script